<template>
  <div :style="customStyle" class="tag-wrp">
    <p
      class="tag-tit"
      :style="{
        color: getTextColor(),
        background: getBgColor(),
        padding: haveBgColor || haveRgbaBgColor ? '2px 12px' : 'none'
      }"
    >
      <slot></slot>
    </p>
  </div>
</template>

<script>
const colorMap = {
  success: '#000000',
  error: '#F4685D',
  info: '#FF943D',
  warning: '#FF943D',
  disabled: '#61636F',
  repeat: '#0063D3'
}

const bgColor = {
  success: 'rgb(12, 159, 105)',
  warning: 'rgb(255, 148, 61)',
  error: 'rgb(244, 104, 93)',
  disabled: 'rgb(97, 99, 111)',
  repeat: 'rgb(0, 99, 211)'
}

const bgColorRgba = {
  success: 'rgb(12, 159, 105, .2)',
  warning: 'rgb(255, 148, 61, .2)',
  error: 'rgb(244, 104, 93, .2)',
  disabled: 'rgb(97, 99, 111, .2)',
  repeat: 'rgb(0, 99, 211, .2)'
}

export default {
  props: {
    customStyle: {
      type: Object,
      default: () => {}
    },
    text: {
      type: String,
      default: ''
    },
    haveBgColor: {
      type: Boolean,
      default: false
    },
    haveRgbaBgColor: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  methods: {
    getBgColor () {
      if (this.haveBgColor) return bgColor[this.type]
      if (this.haveRgbaBgColor) return bgColorRgba[this.type]
      return 'transparent'
    },
    getTextColor () {
      if (this.haveBgColor) return '#fff'
      if (this.haveRgbaBgColor) return bgColor[this.type]
      return colorMap[this.type || 'success']
    }
  }
}
</script>
